
const submitClassificationReference = {
    S: 'S',
    F: 'F',
    J: 'J',
    A_8: '8',
    A_7: '7',
    A_6: '6',
    A_5: '5',
    A_4: '4',
    A_3: '3',
    A_2: '2',
    A_1: '1',
    Y: 'Y',
    A: 'A',
    C: 'C',
}

export function setupCrewMemberFinalData(formData) {

    let data = {...formData, classification: submitClassificationReference[formData.classification]}

    // emergency contacts to delete

    // emergency contacts to add and update
    let addContacts = []
    let updateContacts = []
    formData.emergencyContacts.forEach(contact => {

        if(contact.id) {
            let item = {...contact}
            delete item.__typename
            updateContacts.push(item)
        } else {
            let item = {...contact}
            delete item.id
            addContacts.push(item)
        }

    })
    data['emergencyContactsToAdd'] = [...addContacts]
    data['emergencyContactsToUpdate'] = [...updateContacts]

    // certifications to delete

    // certifications to add and update
    let addCerts = []
    let updateCerts = []
    formData.certifications.forEach(cert => {

        if(cert.id) {
            let item = {...cert, expirationDate: cert.expirationDate.format("YYYY-MM-DD")}
            delete item.__typename
            updateCerts.push(item)
        } else {
            let item = {...cert, expirationDate: cert.expirationDate.format("YYYY-MM-DD")}
            delete item.id
            addCerts.push(item)
        }

    })
    data['certificationsToAdd'] = [...addCerts]
    data['certificationsToUpdate'] = [...updateCerts]

    delete data.emergencyContacts
    delete data.certifications

    return data
}